import { createFileRoute } from "@tanstack/react-router";
import { PlatformUsersPage } from "@/pages/platform-users/ui/platform-users-page";
import { searchParams } from "@/pages/platform-users/model/search-params";

export const Route = createFileRoute("/_authed/$companySlug/admin/users")({
  component: PlatformUsersPage,
  validateSearch: searchParams,
});
